export const CalendarOptionsMapper = {
  mapSowContractTypesForEvent: contractTypes =>
    contractTypes?.map(contractType => ({
      label: contractType.Title,
      value: contractType.Value,
      displayName: contractType.Title
    })),

  mapAtmRolesForEvent: atmRoles =>
    atmRoles?.map(atmRole => ({
      title: atmRole.Title,
      value: atmRole.Value
    }))
};
